import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

const Tab = (_param)=> {
    var { label , onClick , isActive , className , variant ='primary'  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "label",
        "onClick",
        "isActive",
        "className",
        "variant"
    ]);
    return React.createElement("button", swcHelpers.extends({}, rest, {
        onClick: onClick,
        className: classnames(`tab tab--${variant}`, className, {
            _is_active: isActive
        }),
        "aria-pressed": isActive
    }), label);
};
Tab.displayName = 'Tab';

export { Tab as default };
//# sourceMappingURL=Tab.js.map
